// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-links-wrapper {
	padding-top: 1rem;
	padding-bottom: 2rem;
}

.quick-links-title {
	font-size: 1rem;
	color: var(--text);
}

.quick-links-container {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 20px;
}

.quick-links-inner-container {
	text-align: center;
}

.quick-link {
	width: 6rem;
	padding: 1rem 1rem;
	font-size: 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	border-radius: 3px;
	background-color: var(--quick-links-bg);
	color: var(--text);
}

.quick-link-title {
	font-size: 0.8rem;
	margin-top: 0.8rem;
	display: inline-block;
	color: var(--text);
}

.quick-links-icon {
	font-size: 1.5rem;
	font-weight: bold;
}

/* ====== Responsive ====== */

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
	.quick-link-text {
		font-size: 0.6rem;
	}

	.quick-links-container {
		gap: 15px;
	}

	.quick-link {
		width: 4rem;
		padding: 0.5rem;
		font-size: 1rem;
		gap: 10px;
	}

	.quick-links-wrapper {
		padding-bottom: 0;
	}
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
}

/* Large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/layouts/quick-links.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,kBAAkB;CAClB,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA,6BAA6B;;AAE7B,sDAAsD;AACtD;CACC;EACC,iBAAiB;CAClB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,WAAW;EACX,eAAe;EACf,eAAe;EACf,SAAS;CACV;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA,8CAA8C;AAC9C;AACA;;AAEA,+CAA+C;AAC/C;AACA","sourcesContent":[".quick-links-wrapper {\n\tpadding-top: 1rem;\n\tpadding-bottom: 2rem;\n}\n\n.quick-links-title {\n\tfont-size: 1rem;\n\tcolor: var(--text);\n}\n\n.quick-links-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 20px;\n}\n\n.quick-links-inner-container {\n\ttext-align: center;\n}\n\n.quick-link {\n\twidth: 6rem;\n\tpadding: 1rem 1rem;\n\tfont-size: 1rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 10px;\n\tborder-radius: 3px;\n\tbackground-color: var(--quick-links-bg);\n\tcolor: var(--text);\n}\n\n.quick-link-title {\n\tfont-size: 0.8rem;\n\tmargin-top: 0.8rem;\n\tdisplay: inline-block;\n\tcolor: var(--text);\n}\n\n.quick-links-icon {\n\tfont-size: 1.5rem;\n\tfont-weight: bold;\n}\n\n/* ====== Responsive ====== */\n\n/* Small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n\t.quick-link-text {\n\t\tfont-size: 0.6rem;\n\t}\n\n\t.quick-links-container {\n\t\tgap: 15px;\n\t}\n\n\t.quick-link {\n\t\twidth: 4rem;\n\t\tpadding: 0.5rem;\n\t\tfont-size: 1rem;\n\t\tgap: 10px;\n\t}\n\n\t.quick-links-wrapper {\n\t\tpadding-bottom: 0;\n\t}\n}\n\n/* Medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n}\n\n/* Large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
